module.exports = "/_next/static/images/b542c3d2fede2476f59b63a14922ad56-pay-yourself-lg@1x.jpg.webp";